export default class ColorRegistry {
    static SectionTitleColor = '#000000';
    static ActiveFontColor = '#ff4a00';
    static DisableFontColor = '#7f7f7f';
    static ActiveBorderColor = '#000000';
    static BorderColor = '#e0e2e4';

    static CheckBoxFillColor = '#ff4a00';

    static ErrorColor = '#f4a261';
}